var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":_vm.upload,"show-file-list":false,"on-success":_vm.onAvatarSuccess,"before-upload":_vm.beforeAvatarUpload,"headers":_vm.uploadHeaders}},[_c('el-button',{staticClass:"button",attrs:{"size":"small","type":"primary","icon":"el-icon-upload2"}},[_vm._v(_vm._s(_vm.name))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ccc9c1b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tycomponents/Upload/TyImport.vue
// module id = null
// module chunks = 